import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-113401f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "tmTab"
};
const _hoisted_3 = {
  class: "tdTi"
};
const _hoisted_4 = {
  class: "tdBox"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-gou"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "120px"
  }
}, null, -1));
const _hoisted_8 = {
  class: "ret"
};
const _hoisted_9 = {
  class: "yixuan"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已选号码", -1));
const _hoisted_11 = {
  class: "retList"
};
const _hoisted_12 = {
  class: "tmInfo"
};
const _hoisted_13 = {
  style: {
    "color": "red"
  }
};
const _hoisted_14 = {
  key: 0,
  style: {
    "max-width": "800px",
    "position": "fixed",
    "top": "50%",
    "width": "100%",
    "text-align": "center",
    "background": "#00000094",
    "color": "#fff",
    "line-height": "3rem"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.boxList, (box, i) => {
    return _openBlock(), _createElementBlock("div", {
      key: i
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(box.title), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box.content, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        onClick: $event => $options.select(item, index, i),
        class: _normalizeClass({
          act: item.active
        }),
        key: index
      }, [_createTextVNode(_toDisplayString(item.name) + " ", 1), _hoisted_6], 10, _hoisted_5);
    }), 128))])]);
  }), 128))]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.yixuanList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass($options.getCss(item)),
      key: item
    }, _toDisplayString(item | _ctx.numToStr), 3);
  }), 128))])], 512), [[_vShow, $data.yixuan]])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = $event => $data.yixuan = !$data.yixuan)
  }, [_createTextVNode("已选号码("), _createElementVNode("i", _hoisted_13, _toDisplayString($data.yixuanList.length), 1), _createTextVNode(")")]), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.rstSelect && $options.rstSelect(...args))
  }, "重置选择"), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => $options.copy())
  }, "复制结果")]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.showinfo ? (_openBlock(), _createElementBlock("div", _hoisted_14, "复制成功")) : _createCommentVNode("", true)]),
    _: 1
  })]);
}